export default __webpack_public_path__ + "static/media/step4Img.0ee84812.svg";